import AcwMessageBus from '@blk/acw-message-bus';
import { defineCustomElements } from '@blk/bxf-web-components/dist/esm/loader';
import React from 'react';
import ReactDOMClient from 'react-dom/client';
import singleSpaReact from 'single-spa-react';

import { ChatBlk } from './components';
import { ChatBlkTelemetryService } from './services';
import { ChatBlkAppContext } from './types';

const errorHandler = (moduleName: string, message: string) => {
    ChatBlkTelemetryService.trackError({
        moduleName,
        message,
    });
    AcwMessageBus.getInstance()
        .channel()
        .topic<{
            moduleName: string;
            message: string;
        }>('ACW_MFE_FATAL_ERROR')
        .next({
            moduleName,
            message,
        });
};

const lifeCycles = singleSpaReact<ChatBlkAppContext>({
    React,
    ReactDOMClient,
    rootComponent: ChatBlk,
    renderType: 'createRoot',
    errorBoundary(error, _info, props) {
        const moduleName = props.name;
        const { message } = error;

        errorHandler(moduleName, message);

        return <></>;
    },
});

defineCustomElements(window);
const { bootstrap, mount, unmount } = lifeCycles;

export { bootstrap, mount, unmount };
